import { applyDynamicTextScaling } from '@/utils/common';
import { getInstance } from '../../services/animation';
import { preview, thumbnail } from '../../store';
import { hideActiveElementToolbar } from './ActiveElementToolbar/ActiveElementToolbar.svelte';
import { createComponent, initComponents, isComponent } from './Component';
import ImageComponent from './Component/components/ImageComponent';
import EditorUI from './editor-ui';
import editorStore from './editor.store';
import { createImageElement } from './helpers';
import History from './History/history';
let store;
editorStore.subscribe(eStore => (store = eStore));
export class Editor {
    node;
    history;
    ui = new EditorUI();
    // private focusModeEnabled: boolean = false;
    focusedElement = null;
    elements = [];
    unload() {
        console.info('editor unloading...');
        this.node = null;
        editorStore.setRootComponent(null);
        if (this.history) {
            this.history.reset();
            this.history.clear();
        }
    }
    initialize(node) {
        console.log('Initializing editor');
        editorStore.setRootComponent(node);
        this.node = node;
        initComponents();
        this.attachGlobalEventListeners();
        const components = this.attachEventListeners();
        this.removeContentEditable();
        this.initializeHistory();
        if (components)
            editorStore.update(store => ({
                ...store,
                initialized: true,
                components,
                elements: this.elements
            }));
        console.log('Editor initialized');
    }
    get focusModeEnabled() {
        return this.focusedElement && this.focusedElement !== null ? true : false;
    }
    reinitialize(resetHistory = true) {
        if (resetHistory)
            editorInstance.history.reset();
        const components = this.attachEventListeners();
        if (components)
            editorStore.update(store => ({
                ...store,
                initialized: true,
                components,
                elements: this.elements
            }));
    }
    querySelector(query) {
        if (!this.node)
            return null;
        return this.node.querySelector(query);
    }
    activateFocusMode() {
        this.elements.forEach(element => {
            if (element == store.activeComponent) {
                element.setAttribute('data-amoriginal-prefocus-zindex', element.style.zIndex);
                element.setAttribute('data-amoriginal-prefocus-opacity', element.style.opacity);
                element.style.zIndex = '10000';
                element.style.opacity = '0.5';
                this.focusedElement = element;
                return;
            }
            element.style.pointerEvents = 'none';
        });
    }
    getNode() {
        return this.node;
    }
    disableFocusMode() {
        if (!this.focusModeEnabled)
            return;
        this.elements.forEach(element => {
            if (element !== this.focusedElement) {
                const attribute = element.getAttribute('data-amelement');
                if (element.classList.contains('stampElem') &&
                    !(attribute === 'logo' || attribute === 'sermonclip' || attribute === 'thumbnail'))
                    return (element.style.pointerEvents = 'none');
                element.style.pointerEvents = '';
                return;
            }
            let opacity = '1';
            const opacityAttribute = element.getAttribute('data-amoriginal-prefocus-opacity');
            let zIndex = '1';
            const zIndexAttribute = element.getAttribute('data-amoriginal-prefocus-zindex');
            if (opacityAttribute !== null) {
                opacity = opacityAttribute;
            }
            if (zIndexAttribute != null) {
                zIndex = zIndexAttribute;
            }
            element.style.zIndex = zIndex;
            element.style.opacity = opacity;
            this.focusedElement = null;
        });
    }
    addComponent(element, append = false) {
        // editorStore.stopEditting();
        const component = createComponent(element);
        this.attachOnClickListener(element);
        this.attachOnHoverListener(element);
        if (component) {
            this.elements.push(element);
            editorStore.update(store => ({
                ...store,
                activeComponent: null,
                components: [...store.components, component],
                elements: this.elements
            }));
        }
        if (append) {
            const parent = this.node.querySelector('#finalImageToExport');
            if (parent) {
                parent.appendChild(element);
                editorStore.setActiveComponent(element);
                //get width and height of parent
                let width = parent.getBoundingClientRect().width;
                let height = parent.getBoundingClientRect().height;
                if (isComponent(element, ImageComponent)) {
                    //get element's width and height
                    const elemWidth = element.getBoundingClientRect().width;
                    const elemHeight = element.getBoundingClientRect().height;
                    if (elemWidth > width || elemHeight > height) {
                        element.style.width = width + 'px';
                        element.style.height = height + 'px';
                    }
                    else {
                        element.style.width = elemWidth + 'px';
                        element.style.height = elemHeight + 'px';
                    }
                }
            }
            else
                throw 'Unable to find final image to export div';
        }
    }
    insertQuote(text) {
        const textElement = this.node.querySelector('[data-amelement="quote"] .dynamic');
        if (textElement) {
            let width = textElement.parentNode.getBoundingClientRect().width;
            const root = document.getElementById('finalImageToExport');
            // const maxHeight = root.getBoundingClientRect().height - root.getBoundingClientRect().y - 150;
            let maxHeight = textElement.parentNode.getBoundingClientRect().height;
            const qleditor = textElement.querySelector('.ql-editor');
            if (qleditor)
                qleditor.textContent = text;
            else
                textElement.textContent = text;
            applyDynamicTextScaling(textElement, { width, height: maxHeight });
        }
    }
    insertTitle(text) {
        const textElement = this.node.querySelector('[data-amelement="title"] .dynamic');
        if (textElement) {
            let width = textElement.parentNode.getBoundingClientRect().width;
            const root = document.getElementById('finalImageToExport');
            // const maxHeight = root.getBoundingClientRect().height - root.getBoundingClientRect().y - 150;
            let maxHeight = textElement.parentNode.getBoundingClientRect().height;
            const qleditor = textElement.querySelector('.ql-editor');
            if (qleditor)
                qleditor.textContent = text;
            else
                textElement.textContent = text;
            applyDynamicTextScaling(textElement, { width, height: maxHeight });
        }
    }
    insertPastorName(text) {
        const textElement = this.node.querySelector('[data-amelement="pastorname"] .dynamic .ql-editor');
        if (textElement) {
            // let width= (textElement.parentNode as HTMLElement).getBoundingClientRect().width
            // const maxHeight = root.getBoundingClientRect().height - root.getBoundingClientRect().y - 150;
            // let maxHeight= (textElement.parentNode as HTMLElement)!.getBoundingClientRect().height
            textElement.textContent = text;
            // applyDynamicTextScaling(textElement, {width, height: maxHeight});
        }
    }
    insertPastorPic(src) {
        thumbnail.setSnapshot(src);
        if (!src && src === '')
            return false;
        const pastorPicNode = document.querySelector('[data-amelement="thumbnail"]');
        //if pastorPicNode is null create a new one
        if (!pastorPicNode) {
            // const div = document.createElement('div');
            // div.setAttribute('data-amelement', 'thumbnail');
            // div.classList.add('stampElem');
            // div.classList.add('thumbnail');
            // div.style.position = 'absolute';
            // div.style.top = '0';
            // div.style.left = '0';
            // div.style.height = '100%';
            // div.style.display = 'flex';
            // div.style.alignItems = 'center';
            // div.style.justifyContent = 'center';
            // div.style.pointerEvents = 'none';
            // div.innerHTML = `<img src="${src}" style="width:100%; height:100%; object-fit:contain" />`;
            // this.node?.querySelector("#bkgImageContainter")?.appendChild(div);
            const imgEl = createImageElement(src);
            imgEl.style.height = '100%';
            editorInstance.addComponent(imgEl, true);
            console.log(imgEl);
            imgEl.setAttribute('data-amelement', 'thumbnail');
        }
        pastorPicNode?.classList.remove('hidden');
        if (!pastorPicNode) {
            console.warn('Could not find thumbnail node.');
            return false;
        }
        // pastorPicNode.style.display = this.metadata.showBrandLogo ? 'flex' : 'none';
        pastorPicNode.style.alignItems = 'center';
        pastorPicNode.style.justifyContent = 'center';
        const imageNode = pastorPicNode.querySelector('img');
        if (imageNode) {
            imageNode.style.width = '100%';
            imageNode.style.height = '100%';
            imageNode.style.objectFit = 'contain';
            try {
                pastorPicNode.style.objectFit = 'contain';
                pastorPicNode.querySelector('img')?.setAttribute('src', src);
            }
            catch (err) {
                console.warn('Could not apply to logo node.');
            }
        }
    }
    initializeHistory() {
        this.history = new History();
        this.history.observe(this.node);
        this.history.addHistory('New Project');
    }
    attachOnHoverListener(element) {
        element.addEventListener('mouseover', e => {
            // if(! store.active) return;
            e.stopPropagation();
            this.ui.highlight(element);
        });
    }
    attachOnClickListener(element) {
        element.addEventListener('mousedown', e => {
            // if(! store.active) return;
            editorStore.setActiveComponent(element, e);
            e.stopPropagation();
            // e.preventDefault();
        });
    }
    attachEventListeners() {
        const elements = [];
        const components = [];
        this.node.querySelectorAll('div').forEach(element => {
            const component = createComponent(element);
            if (component) {
                elements.push(element);
                components.push(component);
            }
            const attribute = element.getAttribute('data-amelement');
            if (element.classList.contains('stampElem') &&
                !(attribute === 'logo' || attribute === 'sermonclip' || attribute === 'thumbnail' || attribute === 'stamp'))
                return (element.style.pointerEvents = 'none');
            if (component) {
                this.attachOnClickListener(element);
                this.attachOnHoverListener(element);
            }
        });
        this.elements = elements;
        return components;
    }
    async undo() {
        const history = editorInstance.history.undo();
        const time = getInstance().timeline.currentTime;
        hideActiveElementToolbar();
        if (!history) {
            // alert('This is the end of your current history.')
            return false;
        }
        editorStore.setActiveComponent(null);
        const instance = getInstance();
        await instance.buildTemplate(history.dom, true);
        preview.set({
            checkIfSermonTitleExist: instance.checkForSermonTitle(),
            checkIfBrandLogoExists: instance.checkForBrandLogo()
        });
        instance.reattachVideo();
        await instance.buildAnimations(time, () => {
            instance.seekVideo();
        });
        instance.rebuildChanges();
        instance.templateLoader.initializeLoaders();
        editorInstance.reinitialize(false);
        // const components = this.attachEventListeners();
        // instance.reattachVideo();
        // instance.quickBuildAnimations();
        // // editorStore.update(store => ({...store, activeComponent: null, components: components || []}))
        // editorStore.setActiveComponent(null, undefined, {
        //   components: components || [],
        // });
    }
    attachGlobalEventListeners() {
        const body = document.querySelector('body');
        const finalImageArea = document.querySelector('#finalImageToExport');
        if (body) {
            document.addEventListener('keydown', event => {
                // if (!store.active)
                //   return;
                if (event.key === 'Escape') {
                    this.disableFocusMode();
                    editorStore.toggleStylebar(false);
                    editorStore.setPopoverComponent(null);
                    editorStore.setActiveComponent(null);
                }
                if (event.key === 'Delete') {
                    if (store.activeComponent) {
                        if (store.activeComponent?.getAttribute('data-amelement') === 'quote' ||
                            store.activeComponent?.getAttribute('data-amelement') === 'title' ||
                            store.activeComponent?.getAttribute('data-amelement') === 'caption' ||
                            store.activeComponent?.getAttribute('data-amelement') === 'sermonclip')
                            return;
                        if (store.activeComponent?.getAttribute('data-amelement') === 'thumbnail') {
                            store.activeComponent.classList.add('hidden');
                            this.history.addHistory('Hide Thumbnail');
                            return;
                        }
                        this.history.addHistory('Delete Element');
                        store.activeComponent.remove();
                        if (store.activeComponent.classList.contains('userTextClass'))
                            getInstance().templateLoader.textLoader.identifyTextElements();
                        editorStore.setActiveComponent(null);
                    }
                }
                if (event.key === 'z' && event.ctrlKey) {
                    this.undo();
                }
            });
        }
        if (finalImageArea) {
            finalImageArea.addEventListener('mouseleave', e => {
                e.stopPropagation();
                this.ui.removeHighlight();
            });
        }
    }
    removeContentEditable() {
        if (this.node)
            this.node.querySelector('.dynamic')?.removeAttribute('contenteditable');
    }
}
const editorInstance = new Editor();
export default editorInstance;
export const getEditorInstance = () => editorInstance;
